import { render } from "./IconArrowUp.vue?vue&type=template&id=041c70eb&scoped=true"
import script from "./IconArrowUp.vue?vue&type=script&lang=js"
export * from "./IconArrowUp.vue?vue&type=script&lang=js"

import "./IconArrowUp.vue?vue&type=style&index=0&id=041c70eb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041c70eb"]])

export default __exports__